import React, { useContext } from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";
import "./CancelUnavailableModal.sass";
import { MvPrimaryBtn } from "Generic/MvPrimaryBtn";
import moment from "moment";
import MvIcon from "Generic/MvIcon";
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { EXEC_MODE } from "cfg";

type Props = {
    openModal: boolean;
    toggleModal: () => void;
    id?: string
    scrollY?: boolean;
    message: string;
  };
  
  const CancelUnavaliableModal = ({
    openModal,
    toggleModal,
    id,
    scrollY,
    message
  }: Props) => {
    const { localize } = useContext(LocalizationContext);
    if (!openModal) {
        return <div />;
      }

      const handleClose = () => {
        toggleModal();
      }

      const handleContactUsClick =() => {
        if ([ReactAppMode.VCAP].includes(EXEC_MODE)) {
          window.open(`/contactus.jsp`, "_blank");
        } else if ([ReactAppMode.VOA].includes(EXEC_MODE)) {
          window.open(`/timeshare/mvco/contact-us`, "_blank");
        }
      }

      return (
          <React.Fragment>
              <section
                className={`${!openModal ? "cancel-unavailable-main-overlay hide" : "cancel-unavailable-main-overlay"} ${scrollY ? "scroll-y" : ""}`}
                id={id ? id : ""}
              >
                  <div className="content">
                    <div className="content-icon" onClick={handleClose}>
                        <MvIcon
                            color="#5F5F5F"
                            style={{
                                height: "14px",
                                width: "14px"
                            }}
                            icon={"times"}
                        />
                    </div>
                    <div className="content-title">Cancellation Unavailable</div>
                    <div className="content-body">{message}</div>
                    <div className="content-footer">
                        <MvPrimaryBtn
                            isDisabled={false}
                            submissionInProgress={false}
                            text={'Contact Us'}
                            onClick={handleContactUsClick}
                        />
                    </div>
                  </div>
              </section>
              <div
                className={!openModal ? "cancel-unavailable-black-overlay hide" : "cancel-unavailable-black-overlay"}
                onClick={toggleModal}
              >
              </div>
          </React.Fragment>
      )
    }

export default CancelUnavaliableModal;